// TODO make a reactive model (application state), pass it as prop to the components used
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "./styling/globals.css";

import {createRoot} from "react-dom/client";
import { Provider } from "react-redux";
import { store } from './store/store.js';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './routes.jsx';

const router = createBrowserRouter(routes);

const mountedApp = createRoot(document.getElementById('root'));
mountedApp.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);

window.store = store;
